
<div class="row">
  <div class="col-md-12"><div class="col-md-6 col-sm-6"><h3>{{settings.header}}</h3></div></div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="col-md-2 col-sm-2">
      <h4>{{ 'common.search' | translate }}</h4>
    </div>
    <a class="btn btn-primary pull-right" style="margin-bottom:10px;" routerLink="/dashboard/outlet-manager/user-management/add">{{ 'common.addUser' | translate }}</a>
  </div>
</div>
<div class="row">
  <div class="col-md-12 search-row">
    <div class="col-md-4 col-sm-6">
      <label style="margin-right:15px;">{{ 'common.searchBy' | translate }}</label>
      <div class="input-group">
        <div class="input-group-btn">
          <select class="form-control text-center" style="background-color:#ffffff"
                  [ngModel]="field"
                  (change)="search()"
                  (ngModelChange)="field = $event">
            <option value="EmailAddress">{{ 'common.email' | translate }}</option>
            <option value="FullName">{{ 'common.name' | translate }}</option>
          </select>
        </div>
        <input style="height:39px;" type="text" class="form-control" placeholder="Search"
               (keyup)="search()"
               [(ngModel)]="keyword">
      </div>
    </div>
    <div class="col-md-2 col-sm-3">
      <div class="form-group">
        <label style="margin-right:15px;">{{ 'common.roles' | translate }}</label>
        <select class="form-control text-center" style="background-color:#ffffff"
                [ngModel]="role"
                (change)="search()"
                (ngModelChange)="role = $event">
          <option value="0">{{ 'common.all' | translate }}</option>
          <option value="1">{{ 'common.cashier' | translate }}</option>
          <option value="3">{{ 'common.operations' | translate }}</option>
          <option value="2">{{ 'common.outletManager' | translate }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2 col-sm-3">
      <div class="form-group">
        <label style="margin-right:15px;">{{ 'common.status' | translate }}</label>
        <select class="form-control text-center" style="background-color:#ffffff"
                [ngModel]="isActive"
                (change)="search()"
                (ngModelChange)="isActive = $event">
          <option value="true">{{ 'common.active' | translate }}</option>
          <option value="false">{{ 'common.inactive' | translate }}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="responsive-table col-md-12">
  <div class="overlay" *ngIf="reloading"></div>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th *ngFor="let item of data.th; index as i">{{item}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data.tr; index as i">
        <td class="text-center">
          <i class="armx-user-circle-o" style="font-size:24px"></i>
        </td>
        <td>{{item.DisplayName}}</td>
        <td>{{item.EmailAddress}}</td>
        <td [innerHtml]="getIconWithRole(item.Roles)" style="text-transform: capitalize;"></td>
        <td>
            <label class="switch">
              <input type="checkbox" [checked]="item.Active" (change)="activateUser($event,item.UserLocationId)" >
              <span class="slider round"></span>
            </label>
        </td>
        <td>
          <button class="btn btn-primary" data-toggle="modal" (click)="editRow(item.UserLocationId)" data-target="#myModal">{{ 'common.manage' | translate }}</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<nav class="nav-pagination">
  <ul class="pagination">
    <li *ngIf="!(pagesContainer <=1) && (pagger != 0)"><button class="btn " (click)="prevPage()"><span class="armx-icon armx-left-dir"></span></button></li>
    <li *ngIf="!(pagesContainer <=1) && pagger >= 3"><button class="btn " (click)="getSearchPage(0)">1</button> ..</li>
    <li *ngFor="let a of pagesContainer; let index = index">
      <button *ngIf="((index == pagger) || (pagger <= index + 5) && (index > pagger - 3 && index < pagger + 5) ) && !(pagesContainer <=1)" (click)="getSearchPage(index)" class="btn  {{index == pagger ? 'active' : 'no'}}">{{index+1}}</button>
      {{index < pagger && index >= pagger+5 ? '.' : ''}}
      <button class="btn " *ngIf="index == pagesContainer.length" (click)="getSearchPage(pagger)">{{pagger + 1  }}</button>
    </li>
    <li *ngIf="!(pagesContainer <=1) && (pagger <= pagesContainer.length-6)">
      ..
      <button class="btn  {{pagesContainer.length == pagger ? 'active' : 'no'}}" (click)="getSearchPage(pagesContainer.length-1)">{{pagesContainer.length}}</button>
      <button class="btn " (click)="nextPage()"><a><span class="armx-icon armx-right-dir"></span></a></button>
    </li>
  </ul>
</nav>
